import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class ClientTypeEditService {
	private apiUrl = globalConst.baseAPI;

	constructor(private http: Http) { }


	loadClientType(token, ID) {

		return this.http
			.get(this.apiUrl + "clienttypes/v1/getcodclienttype/" + ID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});

	}
	editClientType(token, clienttype: any) {

		return this.http
			.put(this.apiUrl + "clienttypes/v1/updateclienttype", clienttype, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

}



// WEBPACK FOOTER //
// ./src/app/client-type/service/client-type-edit/client-type-edit.service.ts